<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            v-if="roleName == 'BACKENDS ADMIN' && company.id == null"
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Company
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Company Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.tag_line"
                outlined
                label="Tag line"
                prepend-inner-icon="mdi-map-marker"
                :error-messages="errors.tag_line"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone *"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.admin_name"
                outlined
                label="Admin Name"
                prepend-inner-icon="mdi-card-account-phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.gstin"
                outlined
                label="Company GSTIN"
                hint="Printed on the invoice header when GST applies"
                maxlength="15"
                prepend-inner-icon="mdi-file-certificate-outline"
                :error-messages="errors.gstin"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.address"
                outlined
                label="Address *"
                prepend-inner-icon="mdi-map-marker-multiple"
                :error-messages="errors.address"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.state"
                outlined
                label="State "
                prepend-inner-icon="mdi-map-marker"
                :error-messages="errors.state"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.city"
                outlined
                label="City"
                prepend-inner-icon="mdi-map-marker"
                :error-messages="errors.city"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.pincode"
                outlined
                label="Pincode"
                prepend-inner-icon="mdi-map-marker"
                :error-messages="errors.pincode"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <label for="">Franchisee Summary Code</label>
              <v-color-picker
                elevation="2"
                v-model="form.franchisee_array"
                dot-size="25"
                mode="hexa"
                swatches-max-height="200"
                hide-mode-switch
                @input="
                  updateColor(
                    form.franchisee_array,
                    'franchisee_summary_colorcode'
                  )
                "
              ></v-color-picker>
            </v-col>
            <v-col sm="4">
              <label for="">Franchisee Summary Code 2</label>
              <v-color-picker
                elevation="2"
                v-model="form.franchisee_array_2"
                dot-size="25"
                mode="hexa"
                swatches-max-height="200"
                hide-mode-switch
                @input="
                  updateColor(
                    form.franchisee_array_2,
                    'franchisee_summary_colorcode_2'
                  )
                "
              ></v-color-picker>
            </v-col>
            <v-col sm="4">
              <label for="">Franchisee Summary Code 3</label>
              <v-color-picker
                elevation="2"
                v-model="form.franchisee_array_3"
                dot-size="25"
                mode="hexa"
                swatches-max-height="200"
                hide-mode-switch
                @input="
                  updateColor(
                    form.franchisee_array_3,
                    'franchisee_summary_colorcode_3'
                  )
                "
              ></v-color-picker>
            </v-col>
            <v-col sm="4">
              <label for="">Staff Summary Code</label>
              <v-color-picker
                elevation="2"
                v-model="form.staff_array"
                dot-size="25"
                mode="hexa"
                swatches-max-height="200"
                hide-mode-switch
                @input="
                  updateColor(form.staff_array, 'staff_summary_colorcode')
                "
              ></v-color-picker>
            </v-col>
            <v-col sm="4">
              <label for="">Staff Summary Code 2</label>
              <v-color-picker
                elevation="2"
                v-model="form.staff_array_2"
                dot-size="25"
                mode="hexa"
                swatches-max-height="200"
                hide-mode-switch
                @input="
                  updateColor(form.staff_array_2, 'staff_summary_colorcode_2')
                "
              ></v-color-picker>
            </v-col>
            <v-col sm="4">
              <label for="">Staff Summary Code</label>
              <v-color-picker
                elevation="2"
                v-model="form.staff_array_3"
                dot-size="25"
                mode="hexa"
                swatches-max-height="200"
                hide-mode-switch
                @input="
                  updateColor(form.staff_array_3, 'staff_summary_colorcode_3')
                "
              ></v-color-picker>
            </v-col>
            <v-col sm="4">
              <label for=""
                >Company Logo
                <v-btn
                  x-small
                  class="reset_image my-1 ml-5"
                  color="red"
                  dark
                  @click="($refs.file.value = null), (image_url = null)"
                  >Remove</v-btn
                ></label
              >
              <input
                type="file"
                id="file"
                name="file"
                :ref="`file`"
                @change="onFileChange"
              />

              <div id="preview" v-if="image_url" class="mt-5">
                <label for="">Image Preview</label>
                <br />
                <img
                  :src="image_url"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>
            <v-col sm="4">
              <label for=""
                >Explorer Poster
                <v-btn
                  x-small
                  class="reset_image my-1 ml-5"
                  color="red"
                  dark
                  @click="
                    ($refs.explorer_poster.value = null),
                      (explorer_poster_url = null)
                  "
                  >Remove</v-btn
                ></label
              >
              <input
                type="file"
                id="file"
                name="explorer_poster"
                :ref="`explorer_poster`"
                @change="onFileChange"
              />

              <div id="preview" v-if="explorer_poster_url" class="mt-5">
                <label for="">Preview</label>
                <br />
                <img
                  :src="explorer_poster_url"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-2"> </v-divider>
          <h3 class="my-4">List of Flag(s) for this Company:</h3>
          <v-row>
            <v-col sm="3">
              <v-switch
                class="mt-0"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <v-col sm="12">
              <label for="about-us">About Us</label>
              <vue-editor
                ref="about us"
                v-model="form.about_us"
                class="form-control"
              />
            </v-col>
            <v-col sm="12">
              <label for="terms-conditions">Term & Condition</label>
              <vue-editor
                ref="term condition"
                v-model="form.terms"
                class="form-control"
              />
            </v-col>
            <v-col sm="12">
              <label for="privacy-policy">FQAs</label>
              <vue-editor ref="faqs" v-model="form.faqs" class="form-control" />
            </v-col>
            <v-col sm="12">
              <label for="privacy">Privacy Policy</label>
              <vue-editor
                ref="privacy"
                v-model="form.privacy_policy"
                class="form-control"
              />
            </v-col>
            <v-col sm="12">
              <label for="return-policy">Return Policy</label>
              <vue-editor
                ref="return policy"
                v-model="form.return_policy"
                class="form-control"
              />
            </v-col>
            <v-col sm="12">
              <label for="refund-policy">Refund Policy</label>
              <vue-editor
                ref="refund policy"
                v-model="form.refund_policy"
                class="form-control"
              />
            </v-col>
            <v-col sm="12">
              <label for="cancellation-policy">Cancellation Policy</label>
              <vue-editor
                ref="cancellation policy"
                v-model="form.cancellation_policy"
                class="form-control"
              />
            </v-col>
            <v-col sm="12">
              <label for="disclaimer " class="dark-label">Disclaimer</label>
              <vue-editor
                ref="disclaimer"
                v-model="form.disclaimer"
                class="form-control"
              />
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Company
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import { VueEditor } from "vue2-editor";
import axios from "axios";
export default {
  name: "CompanyEditPage",
  components: {
    VueEditor,
  },
  data() {
    return {
      form: {
        name: "",
        franchisee_summary_colorcode: "#1C462BFF",
        franchisee_summary_colorcode_2: "#1C462BFF",
        franchisee_summary_colorcode_3: "#1C462BFF",
        staff_summary_colorcode: "#000000",
        staff_summary_colorcode_2: "#000000",
        staff_summary_colorcode_3: "#000000",
        is_active: true,
      },
      image_url: "",
      explorer_poster_url: "",
      old_json: {},
      isLoading: false,
      isFetching: false,
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.companyId;
      axios
        .get(`/companies/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.form.franchisee_array = this.form.franchisee_summary_colorcode;
          this.form.franchisee_array_2 =
            this.form.franchisee_summary_colorcode_2;
          this.form.franchisee_array_3 =
            this.form.franchisee_summary_colorcode_3;
          this.form.staff_array = this.form.staff_summary_colorcode;
          this.form.staff_array_2 = this.form.staff_summary_colorcode_2;
          this.form.staff_array_3 = this.form.staff_summary_colorcode_3;
          this.old_json = response.data.data;
          this.image_url = this.form.logo_path
            ? `${this.mediaUrl + this.form.logo_path}`
            : "";
          this.explorer_poster_url = this.form.explorer_poster_path
            ? `${this.mediaUrl + this.form.explorer_poster_path}`
            : "";
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.patch(
          `/companies/${this.$route.params.companyId}`,
          this.form
        );
        await this.handleFileUpload();
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
        // if (
        //   this.roleName == "ADMIN" ||
        //   (this.roleName == "SUPER ADMIN" && this.company.id != null)
        // ) {
        //   window.location.href = "/auth/login";
        //   // this.isUnAuthorised();
        // } else {
        //   this.$router.push("/companies");
        // }
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      console.log("called");
      console.log("uploading");
      let formData = new FormData();
      formData.append("id", this.form.id);
      // image_path
      if (this.$refs.file?.files[0]) {
        this.image_path = this.$refs.file.files[0];
        formData.append("logo_path", this.image_path);
      }
      if (this.$refs.explorer_poster != null) {
        let explorer_poster_path = this.$refs.explorer_poster.files[0];
        formData.append("explorer_poster_path", explorer_poster_path);
      }
      await axios
        .post("companies/upload_logo_path", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function (error) {
          console.log(error);
          console.log("FAILURE!!");
        });
    },
    updateColor(color, final) {
      // color is a HEX string if mode="hexa"
      let colorcode = color.hexa ? color.hexa : color;
      switch (final) {
        case "franchisee_summary_colorcode":
          this.form.franchisee_summary_colorcode = colorcode;
          break;
        case "franchisee_summary_colorcode_2":
          this.form.franchisee_summary_colorcode_2 = colorcode;
          break;
        case "franchisee_summary_colorcode_3":
          this.form.franchisee_summary_colorcode_3 = colorcode;
          break;
        case "staff_summary_colorcode":
          this.form.staff_summary_colorcode = colorcode;
          break;
        case "staff_summary_colorcode_2":
          this.form.staff_summary_colorcode_2 = colorcode;
          break;
        case "staff_summary_colorcode_3":
          this.form.staff_summary_colorcode_3 = colorcode;
          break;

        default:
          break;
      }
      console.log(this.form);
    },
    onFileChange() {
      this.warningImageLoader = false;
      this.file = this.$refs.file?.files[0];
      if (this.file) {
        let reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = (evt) => {
          let img = new Image();
          img.onload = () => {
            this.imageLoader = false;
            this.image_url = URL.createObjectURL(this.file);
            this.imageErrors = "";
          };
          img.src = evt.target.result;
        };

        reader.onerror = (evt) => {
          console.error(evt);
        };
      }
      if (this.$refs.explorer_poster?.files[0]) {
        let reader = new FileReader();
        reader.readAsDataURL(this.$refs.explorer_poster?.files[0]);
        reader.onload = (evt) => {
          let ep = new Image();
          ep.onload = () => {
            this.explorer_posterLoader = false;
            this.explorer_poster_url = URL.createObjectURL(
              this.$refs.explorer_poster?.files[0]
            );
            this.explorer_posterErrors = "";
          };
          ep.src = evt.target.result;
        };

        reader.onerror = (evt) => {
          console.error(evt);
        };
      }
      // this.image_url = URL.createObjectURL(this.file);
    },
  },
};
</script>
